import { Flex, Tag } from 'antd';

import { formatNumber } from '@/lib/helpers/formatNumber';
import { formatSecondsToTime } from '@/lib/helpers/formatSecondsToTime';
import { ICategory } from '@/ts';

const columns = [
	{
		title: 'Name',
		dataIndex: 'name',
		key: 'name',
		// sorter: true,
		ellipsis: true,
		width: 180,
		flex: true,
		render: (_: any, record: ICategory) => {
			return <>{record.name}</>;
		},
	},
	{
		title: 'IAB',
		dataIndex: 'iab_categories',
		key: 'iab',
		ellipsis: true,
		width: 100,
		render: (_: any, record: ICategory) => {
			const hasManyCategories = record?.iab_categories?.length > 1;
			return record?.iab_categories?.[0] ? (
				<>
					<Tag color="blue">{record?.iab_categories?.[0]?.name}</Tag>{' '}
					{hasManyCategories
						? `+ ${record?.iab_categories?.length - 1} other(s)`
						: ''}
				</>
			) : (
				'-'
			);
		},
	},
	{
		title: 'Creators',
		dataIndex: 'creators_amount',
		key: 'creators_amount',
		ellipsis: true,
		width: 80,
		render: (_: any, record: ICategory) => {
			return (
				<Flex justify="center" align="center" style={{ width: '100%' }}>
					{!record?.creators_amount
						? '-'
						: formatNumber(record?.creators_amount)}
				</Flex>
			);
			// return record.;
		},
	},
	{
		title: 'Video quantity',
		dataIndex: 'videoQuantity',
		key: 'videoQuantity',
		ellipsis: true,
		width: 80,
		render: (_: any, record: ICategory) => {
			return (
				<Flex justify="center" align="center" style={{ width: '100%' }}>
					{!record?.video_quantity ? '-' : formatNumber(record?.video_quantity)}
				</Flex>
			);
			// return record.;
		},
	},
	// {
	// 	title: 'Duration',
	// 	ellipsis: true,
	// 	dataIndex: 'videoDurationSeconds',
	// 	key: 'videoDurationSeconds',
	// 	render: (_: any, record: ICategory) => {
	// 		return !record?.video_duration
	// 			? '-'
	// 			: formatSecondsToTime(Number(record?.video_duration));
	// 	},
	// },
];

export default columns;
